import { type FC, type ReactNode } from 'react';
import classnames from 'classnames';
import styles from './FullWidthDropdown-style.scss';

type Props = {
    children: ReactNode;
    wrapperClass?: string;
    isVisible?: boolean;
    onShow?: () => void;
};

export const FullWidthDropdown: FC<Props> = ({ children, wrapperClass, isVisible, onShow }) => {
    if (!children) {
        return null;
    }

    const wrapperClasses = classnames(styles.wrapper, wrapperClass);

    const dropdownClasses = classnames(styles.dropdown, {
        [styles.isVisible]: isVisible,
    });
    const bodyWrapperClasses = classnames(styles.bodyWrapper, {
        [styles.isVisible]: isVisible,
    });

    return (
        <div className={wrapperClasses} onMouseEnter={onShow}>
            {children ? (
                <div className={dropdownClasses}>
                    <div className={bodyWrapperClasses}>{children}</div>
                </div>
            ) : null}
        </div>
    );
};
